export default "__VITE_ASSET__Dejuh6lU__"